import React from 'react';
import './Founder.css';

const qualifications = [
  { icon: '📖', degree: 'B.Sc in Psychology',                uni: 'Annamalai University'                },
  { icon: '🎓', degree: 'M.Sc in Psychology',               uni: 'Annamalai University'                },
  { icon: '📋', degree: 'PG Diploma – Learning Disability',  uni: 'Annamalai University'                },
  { icon: '💬', degree: 'PG Diploma – Counselling',          uni: 'Annamalai University'                },
  { icon: '🧠', degree: 'Learning Disability Cert.',         uni: 'Madras Dyslexia Association'         },
  { icon: '🎯', degree: 'Cognitive Behaviour Therapy',       uni: 'SDS Institute of Behavioural Science'}, 
];

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export default function Founder() {
  return (
    <section className="founder-section reveal" id="founder">
      <div className="founder-wrapper">

        {/* ── Section label ── */}
        <div className="founder-header">
          <span className="section-badge">Our Founder</span>
          <h2 className="section-title">The Person Behind Akshara</h2>
        </div>

        {/* ── Single centred card ── */}
        <div className="founder-card">

          {/* Accent bar */}
          <div className="fcard-accent" />

          {/* Top: tag + decorative quote */}
          <div className="fcard-top">
            <span className="fcard-tag">Founder's Note</span>
            <span className="fcard-decor">"</span>
          </div>

          {/* Headline quote */}
          <h3 className="fcard-headline">
            Every child learns differently,<br />
            and every child deserves to be understood.
          </h3>

          <div className="fcard-divider" />

          {/* Body paragraphs */}
          <div className="fcard-body">
            <p>
              When I started Akshara Learning Centre, I had one clear purpose — to make sure
              no child feels left behind simply because they learn differently. Over the years,
              I have seen children struggle not because they lack ability, but because they
              haven't been taught in a way that works for them.
            </p>
            <p>
              At Akshara, we take time to understand each student — their strengths, their
              challenges, and their pace. Through structured teaching, individual attention,
              and consistent parent support, we help children build confidence, improve learning
              skills, and move forward steadily.
            </p>
            <p>
              Academic challenges are not a sign of inability. They are a sign that the child
              needs a different approach. That is exactly what we provide.
            </p>
          </div>

          {/* Signature row */}
          <div className="fcard-sig-row">
            <div className="fcard-avatar">DK</div>
            <div>
              <p className="fcard-sig-name">— Durga Karikalan</p>
              <p className="fcard-sig-role">
                Founder &amp; Special Educator, Akshara Learning Centre
              </p>
            </div>
          </div>

          {/* Qualifications — below signature */}
          <div className="fcard-quals">
            <p className="fcard-quals-title">Qualifications &amp; Certifications</p>
            <div className="fcard-quals-grid">
              {qualifications.map((q, i) => (
                <div className="fcard-qual-item" key={i}>
                  <span className="fcard-qual-icon">{q.icon}</span>
                  <div>
                    <p className="fcard-qual-degree">{q.degree}</p>
                    <p className="fcard-qual-uni">{q.uni}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="fcard-cta-row">
            <button
              className="fcard-cta"
              onClick={() => scrollTo('contact')}
            >
              Talk to the Founder →
            </button>
          </div>

        </div>{/* end card */}
      </div>
    </section>
  );
}
